import { AbholzeitType, Terminart } from "@/entities/common/enums"
import Oeffnungszeiten, { Oeffnung } from "@/entities/common/oeffnungszeiten"
import moment from "moment"
import store from "@/store"
import router from "@/router"
import RouteNames from "@/util/route_names"
import RemoteResult from "@/entities/common/remote_result"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import OeffnungRequest from "@/entities/common/request/oeffnung_request"
import BPLieferungTerminWaehlenRequest from "@/entities/common/pending/bp_lieferung_termin_waehlen_request"
import BaseLogic from "../base_logic"
import MainLogic from "../main_logic"

export default class TerminLieferungLogic extends BaseLogic {
  selectedLieferType: string = AbholzeitType.BALDEST
  private _selectedDate?: string = null
  selectedTime?: string = null
  selectedOeffnung: Oeffnung = null
  geoeffneteTage: Oeffnung[] = null
  minDate?: string = null
  maxDate?: string = null
  uhrzeiten = []

  insertWorking: boolean = false
  insertError: boolean = false

  editMode: boolean = false

  get selectedDate(): string {
    return this._selectedDate
  }

  get abholtypes() {
    if (!this.filiale) return null
    if (!this.filiale.zurZeitGeoeffnetLieferung) {
      return [{ label: "Termin wählen", value: AbholzeitType.UHRZEIT }]
    }
    return [
      { label: "Schnellstmöglich", value: AbholzeitType.BALDEST },
      { label: "Termin wählen", value: AbholzeitType.UHRZEIT },
    ]
  }

  get weiterDisabled(): boolean {
    if (this.selectedLieferType == AbholzeitType.BALDEST) return false
    if (this.selectedDate == null || this.selectedTime == null) return true
    return false
  }

  set selectedDate(value: string) {
    this._selectedDate = value

    let oeffnung = null

    this.geoeffneteTage.forEach((toCompare) => {
      if (toCompare.datum == value) {
        oeffnung = toCompare
        return
      }
    })
    this.selectedOeffnung = oeffnung

    var uz = []
    this.selectedOeffnung.oeffnungszeiten.forEach((oz) => {
      var vonTemp = moment(oz.zeitVon, "HH:mm:ss").clone()
      var bis = moment(oz.zeitBis, "HH:mm:ss")

      while (vonTemp.isBefore(bis)) {
        uz.push(vonTemp.clone())
        vonTemp.add(15, "minutes")
      }
    })
    this.uhrzeiten = uz.map((el) => {
      return el.format("HH:mm")
    })
  }

  terminBearbeiten() {
    this.editMode = true
  }

  terminAuswaehlen() {
    this.insertWorking = true
    this.insertError = false

    var request = new BPLieferungTerminWaehlenRequest()
    request.id = store.state.user.identifier
    request.type = this.selectedLieferType
    if (this.selectedLieferType == AbholzeitType.UHRZEIT) {
      request.zeitpunkt = this._selectedDate + "T" + this.selectedTime
    }

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingLieferungTermin,
      request
    )
      .then((response) => {
        if (response.data.success) {

          this.mainLogic.bestellungPending.lieferung.abholzeitType =
            this.selectedLieferType
          if (this.selectedLieferType == AbholzeitType.UHRZEIT) {
            this.mainLogic.bestellungPending.lieferung.gewaehlteUhrzeit =
              response.data.payload
          }

          router.push({
            name: RouteNames.NEU.SHOPPING_LIEFERUNG.PRODUKTE,
          })
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }

  weiter() {
    router.push({
      name: RouteNames.NEU.SHOPPING_LIEFERUNG.PRODUKTE,
    })
  }

  abholzeitType: string
  termin: string

  init() {
    this.abholzeitType =
      this.mainLogic.bestellungPending.lieferung.abholzeitType
    this.termin =
      this.mainLogic.bestellungPending.lieferung.gewaehlteUhrzeit

    if (this.abholzeitType != null) {
      this.editMode = false
    } else {
      this.editMode = true
    }

    if (!this.filiale.zurZeitGeoeffnetLieferung) {
      this.selectedLieferType = AbholzeitType.UHRZEIT
    }

    var filialeId = this.filiale.filialeId
    var request = new OeffnungRequest()
    request.filialeId = filialeId
    request.terminart = Terminart.LIEFERUNG

    Poster.postUser<RemoteResult<Oeffnungszeiten>>(
      RestPaths.oeffnungszeitOeffnungszeitenLieferung,
      request
    ).then((response) => {
      this.minDate = response.data.payload.minDate
      this.maxDate = response.data.payload.maxDate
      this.geoeffneteTage = response.data.payload.daten
    })
  }

  datumWaehlen() {}
}
